import { styled, Typography } from '@material-ui/core'

export const Title = styled(Typography)(({ theme }) => ({
  color: theme.palette.primary.main,
  fontWeight: 500,
  fontSize: 16,
  lineHeight: '19px',
}))

export const OptionalLabel = styled('span')(({ theme }) => ({
  color: theme.palette.common.black,
  fontWeight: 300,
}))
